import * as React from 'react'
import { Route, RouteProps } from 'react-router-dom'

import { GenericError, Loader } from 'main/components/common'
import { AppContext } from 'main/framework'
import { loginPath } from 'main/routes'
import { userType, UserType } from 'main/util/user'

type RoutePropsWithoutRender = Omit<RouteProps, 'render' | 'component'>
type RouteComponentRequired = Required<Pick<RouteProps, 'component'>>

type Props = RoutePropsWithoutRender &
  RouteComponentRequired & {
    adminRequired?: boolean
    parentExclusive?: boolean
    componentProps?: any
  }

const TIMEOUT = 3500

export default function AuthenticatedRoute(props: Props) {
  const { adminRequired, componentProps, parentExclusive, component: Component, ...rest } = props
  const { user } = React.useContext(AppContext)
  const [didTimeout, setDidTimeout] = React.useState(false)
  const hasUser = !!user
  const hasUserRights =
    hasUser &&
    (!adminRequired || user.admin) &&
    (!parentExclusive || userType(user) !== UserType.Director)
  const hasBackupUser = !!window.lego.user

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasUser && !hasBackupUser) {
        setDidTimeout(true)
      }
    }, TIMEOUT)
    return () => {
      clearTimeout(timer)
    }
  })

  return (
    <Route
      {...rest}
      render={routerProps => {
        if (hasUser) {
          if (hasUserRights) {
            return <Component {...routerProps} {...componentProps} />
          } else {
            return <GenericError heading="You don't have access to this page." />
          }
        } else if (didTimeout) {
          // wait a minimum amount of time to check for user presence
          window.location.replace(loginPath(window.location.href))
        }
        return <Loader />
      }}
    />
  )
}
